var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMessageSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 19 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5378_9137)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.2708 14H3.27075C1.62075 14 0.270752 12.65 0.270752 11V3C0.270752 1.35 1.62075 0 3.27075 0H15.2708C16.9208 0 18.2708 1.35 18.2708 3V11C18.2708 12.65 16.9208 14 15.2708 14ZM3.27075 2C2.72075 2 2.27075 2.45 2.27075 3V11C2.27075 11.55 2.72075 12 3.27075 12H15.2708C15.8208 12 16.2708 11.55 16.2708 11V3C16.2708 2.45 15.8208 2 15.2708 2H3.27075Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.27065 10C9.01065 10 8.76065 9.90002 8.56065 9.71002L1.15065 2.30002C0.760654 1.91002 0.760654 1.28002 1.15065 0.890024C1.54065 0.500024 2.17065 0.500024 2.56065 0.890024L9.26065 7.59002L15.9707 0.880024C16.3607 0.490024 16.9907 0.490024 17.3807 0.880024C17.7707 1.27002 17.7707 1.90002 17.3807 2.29002L9.97065 9.70002C9.77065 9.90002 9.52065 9.99002 9.26065 9.99002L9.27065 10Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6306 13.45C16.4006 13.45 16.1706 13.37 15.9806 13.21L10.1606 8.21998C9.74063 7.85998 9.69063 7.22998 10.0506 6.80998C10.4106 6.38998 11.0406 6.33998 11.4606 6.69998L17.2806 11.69C17.7006 12.05 17.7506 12.68 17.3906 13.1C17.1906 13.33 16.9106 13.45 16.6306 13.45Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.91073 13.45C1.63073 13.45 1.35073 13.33 1.15073 13.1C0.790728 12.68 0.840728 12.05 1.26073 11.69L7.08073 6.69998C7.50073 6.33998 8.13073 6.38998 8.49073 6.80998C8.85073 7.22998 8.80073 7.85998 8.38073 8.21998L2.56073 13.21C2.37073 13.37 2.14073 13.45 1.91073 13.45Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5378_9137"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 14,
  fill: "white",
  transform: "translate(0.270752)"
})))));
export default SvgIconMessageSmall;